import { render, staticRenderFns } from "./call-recordings-table.vue?vue&type=template&id=8bd78c76&scoped=true&"
import script from "./call-recordings-table.vue?vue&type=script&lang=js&"
export * from "./call-recordings-table.vue?vue&type=script&lang=js&"
import style0 from "./call-recordings-table.vue?vue&type=style&index=0&id=8bd78c76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd78c76",
  null
  
)

export default component.exports